import './App.css';
import {Navigate, Route, Routes} from "react-router-dom";
import NewGame from "./components/NewGame";
import Game from "./components/Game";
import Winner from "./components/Winner";

function BarQuest() {
    document.title = "Nacho Spin"
    return (
        <div className={"body"}>
            <Routes>
                <Route path={"/"} element={<NewGame/>}/>
                <Route path={"/game"} element={<Game/>}/>
                <Route path={"/winner"} element={<Winner/>}/>
                <Route path={'*'} element={<Navigate to="/"/>}/>
            </Routes>
        </div>
    )
}

export default BarQuest;